<template>
    <modal
        :show="showModal('actionsLog')"
        :renderCustomContent="true"
        :renderCloseBtn="true"
        type="actionsLog"
    >
        <template v-slot:content>
<div class="actions-log-modal-content" >
            <div class="actions-log">
                <div class="action-log"
                    :key="`action-log-${index}`"
                    :class="{[log.color]: true}"
                    v-for="(log, index) of actionsLog"
                >
                    <span class="action-log-index">
                        {{actionsLog.length - index}}
                    </span>
                    <span class="action-log-icon">
                        <royal-coin :color="log.color" :theme="theme" />
                    </span>
                    <span class="action-log-text"> {{ log.label }} </span>
                </div>
            </div>
        </div>
</template>
    </modal>
</template>

<script>

export default {
    name: 'ActionsLogModal',
    props: ['lastLogIndex'],
    computed: {
        actionsLog() {
            const actionsLog = this.$store.state.actionsLogState.actionsLog;

            if (this.lastLogIndex) {
                return actionsLog.slice(0 - this.lastLogIndex);
            }

            return actionsLog;
        },
        theme() {
            return this.$store.state.gameState.theme;
        },
    },
    methods: {
        showModal(type) {
            return this.$store.state.modalState.modals[type].show;
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .actions-log-modal-content {

        .actions-log {
            box-sizing: border-box;
            max-height: 450px;
            overflow: auto;
            width: 100%;

            .action-log {
                border-bottom: 1px solid $silver;
                box-sizing: border-box;
                font-size: .9rem;
                padding: 5px 15px 5px 5px;
                width: 100%;
                display: flex;

                > * {
                    align-self: center;
                }

                &:first-of-type {
                    border-top: 1px solid $silver;
                }

                .action-log-index {
                    min-width: 25px;
                    text-align: right;
                }

                .action-log-text {
                    text-align: left;
                    margin-left: 10px;
                }
            }

            .royal-coin {
                display: block;
                height: 18px;
                margin-left: 8px;
                width: 18px;
            }
        }
    }

</style>
